import { useEffect } from 'react';

const useClickOutside = (callback: (target: Node) => void): void => {
    useEffect(() => {
        const handleClickOutside = (event: Event): void => {
            const node = event.type === 'blur' ? document.body : event.target;
            callback(node as Node);
        };

        window.addEventListener('blur', handleClickOutside);
        document.addEventListener('click', handleClickOutside, { capture: true });
        document.addEventListener('touchstart', handleClickOutside);

        return () => {
            window.removeEventListener('blur', handleClickOutside);
            document.removeEventListener('click', handleClickOutside, { capture: true });
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, []);
};

export default useClickOutside;
